import { LoginWithGoogleResponse } from "@syla/shared/types/responses/LoginWithGoogleResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function loginWithGoogle(params: {
  credential: string;
}): Promise<LoginWithGoogleResponse> {
  try {
    const { data } = await axios.post("/users/login/google", params);
    return data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
